import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";

interface CircleFormData {
  latitude: string;
  longitude: string;
  radius: string;
}

interface MapFormProps {
  form: UseFormReturn<CircleFormData>;
  onSubmit: () => void;
  handleUpdateCircleRadius: (increment: number) => void;
}

const MapForm: React.FC<MapFormProps> = ({
  form,
  onSubmit,
  handleUpdateCircleRadius,
}) => {
  const handleRadiusChange = (increment: number) => {
    const currentRadius = Number(form.getValues("radius")) || 0;
    const newRadius = Math.max(0, currentRadius + increment);
    form.setValue("radius", newRadius.toString(), { shouldValidate: true });
    handleUpdateCircleRadius(newRadius);
  };

  return (
    <div className="absolute bottom-8 right-8 z-1000">
      <Card className="bg-white dark:bg-slate-900 shadow-lg border border-gray-200 dark:border-gray-800 text-xs">
        <CardContent className="p-4 space-y-2">
          <FormField
            control={form.control}
            name="latitude"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="text-gray-700 dark:text-gray-200">
                  Latitude
                </FormLabel>
                <FormControl>
                  <Input
                    placeholder="Digite a latitude"
                    {...field}
                    type="number"
                    step="any"
                    className="bg-gray-50 dark:bg-slate-800 border-gray-200 dark:border-gray-700 h-8"
                  />
                </FormControl>
                <FormMessage className="text-red-500" />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="longitude"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="text-gray-700 dark:text-gray-200">
                  Longitude
                </FormLabel>
                <FormControl>
                  <Input
                    placeholder="Digite a longitude"
                    {...field}
                    type="number"
                    step="any"
                    className="bg-gray-50 dark:bg-slate-800 border-gray-200 dark:border-gray-700 h-8"
                  />
                </FormControl>
                <FormMessage className="text-red-500" />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="radius"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="text-gray-700 dark:text-gray-200">
                  Raio (metros)
                </FormLabel>
                <div className="flex items-center gap-2">
                  <Button
                    type="button"
                    onClick={() => handleRadiusChange(-20)}
                    className="bg-gray-300 dark:bg-gray-700 px-3 h-8"
                  >
                    -
                  </Button>
                  <FormControl>
                    <input
                      {...field}
                      placeholder="Raio"
                      type="number"
                      min="0"
                      step="any"
                      className="bg-gray-50 dark:bg-slate-800 border-gray-200 dark:border-gray-700 h-8 text-center w-24 rounded-md border bg-background text-sm px-3 py-2"
                    />
                  </FormControl>
                  <Button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRadiusChange(20);
                    }}
                    className="bg-gray-300 dark:bg-gray-700 px-3 h-8"
                  >
                    +
                  </Button>
                </div>
                <FormMessage className="text-red-500" />
              </FormItem>
            )}
          />

          <Button
            type="button"
            onClick={onSubmit}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white dark:bg-blue-700 dark:hover:bg-blue-800 h-8"
          >
            Desenhar círculo
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default MapForm;
